import React from 'react';
import styles from './index.css';
import CloseIcon from './close_icon.svg';
import ReactDOM from 'react-dom';

const handleParentClick = cb => event => {
	if (event.target === event.currentTarget) {
		event.preventDefault();
		cb(event);
	}
};

let Modal = ({ children, title, ...props }) =>
	ReactDOM.createPortal(
		<div className={styles.Modal} onClick={handleParentClick(props.onClose)}>
			<div className={styles.ModalBody}>
				<div className={styles.ModalHeader}>
					{title}
					<CloseIcon onClick={props.onClose} alt="close" />
				</div>
				<div className={styles.ModalContent}>{children}</div>
			</div>
		</div>,
		document.getElementById('modal-root'),
	);

export default Modal;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/utils/Modal/index.js